import React from 'react';

import classNames from 'classnames';
import classes from './styles.module.scss';
import deleteIcon from '../../../assets/images/create-meeting/deleteIcon.svg';

export default function File({ file, onDelete, readOnly, onClick }) {
  const fileName = file.name || file.fileName || 'Untitled';

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (readOnly) {
      window.open(file.signedS3Url || file.url, '_blank');
    }
  };

  return (
    <div
      className={classNames(classes.File, {
        [classes.readOnly]: readOnly,
      })}
      onClick={handleClick}
    >
      <div className={classes.fileContent}>
        <div className={classes.documentIcon}>📄</div>
        <div className={classes.fileName}>
          {fileName}
        </div>
      </div>
      {!readOnly && (
        <button
          className={classes.deleteButton}
          onClick={(e) => {
            e.stopPropagation();
            if (file.url) {
              onDelete(file);
            } else {
              onDelete();
            }
          }}
          type="button"
          aria-label="Remove file"
        >
          <img src={deleteIcon} alt="Remove" />
        </button>
      )}
    </div>
  );
}
